export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';

export const updateUserSuccess = ({ user }) => ({
    type: UPDATE_USER_SUCCESS,
    payload: {
        user,
    },
});
